// src/utils/SnapchatEventsApi.js
import axios from "axios";

// Snapchat config (use env vars in production)
const SNAPCHAT_PIXEL_ID = "70249559-9cf4-49f0-babc-3e1259c9801b";
const SNAPCHAT_ENDPOINT = "snapchatEvents";

export const sendSnapchatEvent = async ({
  pixelId = SNAPCHAT_PIXEL_ID,
  baseUrl = "https://dodeal.dodealcrm.com/api/",
  endpoint = SNAPCHAT_ENDPOINT,
  eventName,
  phone,
  url = window.location.href,
  testEventcode,
}) => {
  try {
    const payload = {
      pixel_id: pixelId,
      event: eventName,
      phone,
      url,
      test_event_code: testEventcode,
    };
    const response = await axios.post(`${baseUrl}${endpoint}`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.json();
  } catch (error) {
    console.error("Error sending Snapchat event:", error);
    return { success: false, error };
  }
};
